import React from 'react';
import { Button, Icon, useDisclosure } from '@wegroup/design-system';
import CompanySuccessActionBox from './CompanySuccessActionBox';
import { useTranslation } from 'react-i18next';
import ShareCompanyScanConversationModal from './ShareCompanyScanConversationModal';
import { useLocale } from '../../../../../i18n';
import AskLaterQuestionsModal from '../../../../flows/src/components/ui/company-scan/components/ask-later-questions/AskLaterQuestionsModal';
import { useAskLaterQuestions } from '../../../../flows/src/components/ui/company-scan/components/ask-later-questions/api/getAskLaterQuestion';
import useAskLaterTree from '../../../../flows/src/components/ui/company-scan/components/ask-later-questions/hooks/useAskLaterTree';
import useIsNLplan from '../../../../common/src/hooks/useIsNLPlan';
import {
  flowIdCompanyScanBE,
  flowIdCompanyScanNL,
} from '../../../../flows/src/constants/flowIds';
import { useParty } from '../../../../parties/src/features/detail/api/getParty';

interface Props {
  partyId: string;
}

const CompanySuccessShareConvoActionBox: React.FC<Props> = ({ partyId }) => {
  const { t } = useTranslation();
  const { isNL } = useIsNLplan();

  const { isOpen, onClose, onOpen } = useDisclosure();
  const { data: party, isLoading } = useParty(partyId);
  const { userLang } = useLocale();
  const questionsModal = useDisclosure();
  const { data: askLater } = useAskLaterQuestions({
    flowId: isNL ? flowIdCompanyScanNL : flowIdCompanyScanBE,
    partyId,
  });
  const { treeItems, isLoading: isLoadingQuestions } = useAskLaterTree(
    isNL ? flowIdCompanyScanNL : flowIdCompanyScanBE,
    askLater?.questions,
  );

  return (
    <>
      <AskLaterQuestionsModal
        questionList={askLater?.questions}
        data={treeItems}
        isOpen={questionsModal.isOpen}
        onClose={questionsModal.onClose}
      />
      {party && (
        <ShareCompanyScanConversationModal
          isOpen={isOpen}
          onClose={onClose}
          partyLang={party.native_language || userLang}
          partyId={partyId}
          leftElement={
            <Button
              mr="auto"
              onClick={questionsModal.onOpen}
              variant="grayedGhost"
              isLoading={isLoadingQuestions}
            >
              {t('COMPANY-SCAN_SEND-CONVO_URL_MODAL_ACTION_VIEW-QUESTIONS')}
            </Button>
          }
        />
      )}
      <CompanySuccessActionBox
        icon={<Icon name="GeneralActionsSendEmail" />}
        title={t('COMPANY-SCAN_RECOMMENDATIONS_SEND_TITLE')}
        description={t('COMPANY-SCAN_RECOMMENDATIONS_SEND_DESCRIPTION')}
        onClick={onOpen}
        isLoading={isLoading}
      />
    </>
  );
};

export default CompanySuccessShareConvoActionBox;
